import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SBADropDown } from "../../../../UiComponents/SBADropDown";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { SBDatePicker } from "../../../../UiComponents/SBDatePicker";
import moment from "moment";
export const AllocationTab = ({ OptionDate, ActiveButton, setAllocationParams, allocationParams }) => {
  const dispatch = useDispatch();
  const Gstate = useSelector((state) => state) || {};
  const proformaParmsData = Gstate.ProformaConstruction.ProformaTreeListData || [];
  const ProformaDDData = Gstate.ProformaConstruction || [];
  const proformaStartDateData = ProformaDDData.ProformaDateData || [];
  const proformaEndDateData = proformaStartDateData;
  const proformaRebalanceData = ProformaDDData.ProformaRebalanceData || [];
  const ProformaBackfillData = ProformaDDData.ProformaBackfillData || [];

  const currentDate = new Date();
 
  
  const proformaRebalanceStartData = Array.from({ length: 12 }, (_, index) => {
    const currentDate = new Date(); // Create a new Date object for each iteration
    currentDate.setMonth(index, 1); // Set the day to 1
    const monthName = currentDate.toLocaleString('default', { month: 'long' });
    return { index: index + 1, month: monthName };
  });

  const allocationModeOptions = [
    { OptionId: "0", OptionDescription: "%" },
    { OptionId: "1", OptionDescription: "$" },
  ];

  const [initalValue, setInitalValue] = useState(1000000);
  const [selectDateOption, setSelectDateOption] = useState("");
  const [selectedProformaEndDateData, setProformaEndDateData] = useState("");
  const [selectedProformaRebalanceData, setProformaRebalanceData] = useState("");
  const [selectedProformaRebalanceStartData, setProformaRebalanceStartData] = useState("");
  const [selectedProformaBackfillData, setProformaBackfillData] = useState("");
  const [allocationMode, setAllocationMode] = useState("");
  const [automateReturns, setAutomateReturns] = useState("");
  const [fees, setFees] = useState("");
  const [feesValue, setFeesValue] = useState("");
  const fixedDate=proformaParmsData?.FromDate ?  proformaParmsData?.FromDate : new Date()
  const [selectedFromDate, setSelectedFromDate] = useState(OptionDate !== "New" ? fixedDate : new Date());
  
  useEffect(() => {
    if (ActiveButton === "Allocation") {
      setSelectedFromDate(proformaParmsData.FromDate && (moment(proformaParmsData.FromDate).format('MM/DD/YYYY')));
      const startDate = {
        "OptionId": proformaParmsData?.HypoParameters ? proformaParmsData?.HypoParameters[0]?.StartDateOptionId : null,
        "OptionDescription": proformaParmsData?.HypoParameters ? proformaParmsData?.HypoParameters[0]?.StartDateOption : null,
        "OptionType": "DATE"
      };
      setSelectDateOption(startDate);

      const endDate = {
        "OptionId": proformaParmsData?.HypoParameters ? proformaParmsData?.HypoParameters[0]?.EndDateOptionId : null,
        "OptionDescription": proformaParmsData?.HypoParameters ? proformaParmsData?.HypoParameters[0]?.EndDateOption : null,
        "OptionType": "DATE"
      };
      setProformaEndDateData(endDate);

      const backFill = {
        "OptionId": proformaParmsData?.HypoParameters ? proformaParmsData?.HypoParameters[0]?.BackfillOptionId : null,
        "OptionDescription": proformaParmsData?.HypoParameters ? proformaParmsData?.HypoParameters[0]?.BackfillOption : null,
        "OptionType": "BF"
      };
      setProformaBackfillData(backFill);

      const rebalanceMethod = {
        "OptionId": proformaParmsData?.HypoParameters ? proformaParmsData?.HypoParameters[0]?.RebalanceMethodId : null,
        "OptionDescription": proformaParmsData?.HypoParameters ? proformaParmsData?.HypoParameters[0]?.RebalanceMethod : null,
        "OptionType": "RBM"
      };
      setProformaRebalanceData(rebalanceMethod);

      const rebalanceStartDate = proformaParmsData?.HypoParameters ? proformaParmsData?.HypoParameters[0]?.RebalanceStartId : null;
      setProformaRebalanceStartData(proformaRebalanceStartData.find(item => item.index === rebalanceStartDate));

      setAllocationMode(proformaParmsData?.AllocationMode > -1 ? allocationModeOptions[proformaParmsData?.AllocationMode] : null);

      setAutomateReturns(proformaParmsData?.AutomateReturns ? proformaParmsData?.AutomateReturns : false);

      setFees(proformaParmsData?.FeesPercentage ? proformaParmsData?.FeesPercentage : false);

      setFeesValue(proformaParmsData?.FeesPercentageValue !== null ? proformaParmsData?.FeesPercentageValue : "");
      setInitalValue(proformaParmsData?.Position);
     
    }
    // else {
    //   setSelectDateOption(
    //     {
    //       "OptionId": null,
    //       "OptionDescription": null,
    //       "OptionType": "DATE"
    //     }
    //   );
    //   setProformaBackfillData(
    //     {
    //       "OptionId": null,
    //       "OptionDescription": null,
    //       "OptionType": "BF"
    //     }
    //   );
    //   setProformaEndDateData({
    //     "OptionId": null,
    //     "OptionDescription": null,
    //     "OptionType": "DATE"
    //   });
    //   setProformaRebalanceData(
    //     {
    //       "OptionId": null,
    //       "OptionDescription": null,
    //       "OptionType": "RBM"
    //     }
    //   )
    //   setProformaRebalanceStartData({
    //     "index": null,
    //     "month": null,
    //   });
    //   setAllocationMode(
    //     {
    //       "OptionId": "0",
    //       "OptionDescription": "%",
    //     }
    //   )
    //   setAutomateReturns(null);
    //   setFees(false);
    //   setFeesValue(null);
    //   setInitalValue(1000000);
    // }
  }, [ActiveButton, proformaParmsData]);
  useEffect(() => {
    const updatedParams = { ...allocationParams };
    updatedParams.InitialValue = initalValue;
    updatedParams.StartDate = selectDateOption;
    updatedParams.EndDate = selectedProformaEndDateData;
    updatedParams.Backfill = selectedProformaBackfillData;
    updatedParams.RebalanceMethod = selectedProformaRebalanceData;
    updatedParams.RebalanceStart = selectedProformaRebalanceStartData;
    updatedParams.AllocationMode = allocationMode;
    updatedParams.AutomatedReturns = automateReturns;
    updatedParams.Fees = fees;
    updatedParams.FeesPercentage = feesValue;
    updatedParams.FromDate=selectedFromDate;
    updatedParams.IsInitialChange=false;
    setAllocationParams(updatedParams);
  }, [
    initalValue,
    selectDateOption,
    selectedProformaEndDateData,
    selectedProformaBackfillData,
    selectedProformaRebalanceData,
    selectedProformaRebalanceStartData,
    allocationMode,
    automateReturns,
    fees,
    feesValue,
    selectedFromDate
  ]);
 const FeesPercentageChange=(event)=>{
  if (event.target.value > 0.99)
{
setFeesValue(0.99);
}
else
{
  setFeesValue(event.target.value);
}
if (event.target.value  < 0)
{
setFeesValue(0);
}
 }
 const FromdateChange = (e) => {
  const updatedParams = { ...allocationParams };
  var formattedDate =new Date(moment(e._d).format('MM/DD/YYYY'));
  var jsDate = new Date(formattedDate);
  var shortDateString = jsDate.toLocaleDateString(); 
  updatedParams.FromDate = shortDateString;
  setAllocationParams(updatedParams);
  setSelectedFromDate(shortDateString);
    };

  return (
    <>
      <div className="col-lg-12">
        <div className="col-lg-3">
          <h2 className="fw-bold fs-6 mb-4">Parameters</h2>
        </div>
      </div>
      <div className="col-lg-12 m-0">
        <div className="col-lg-12 row">
          <div className="col-md-3">
            <div className="mb-4">
              <span className="fw-medium">Initial Value</span>
              <input
                className="form-control w-75"
                type="text"
                value={initalValue}
                onChange={(event) => {
                  const updatedParams = { ...allocationParams };
                  updatedParams.InitialValue = event.target.value;
                  updatedParams.IsInitialChange=true;
                  setAllocationParams(updatedParams);
                  setInitalValue(event.target.value);
                }}
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-4">
              <span className="fw-medium">Start Date</span>
              <div className="w-75">
                <SBADropDown
                  data={proformaStartDateData}
                  textField={"OptionDescription"}
                  valueField={"OptionId"}
                  value={selectDateOption}
                  onChange={(event) => {
                    setSelectDateOption(event.value);
                  }}
                />
              </div>
            </div>

            {allocationParams?.StartDate?.OptionId === 2 && (
              <div>
                <SBDatePicker
                  className="w-75"
                  value={moment(selectedFromDate)}
                  onChange={FromdateChange}
                ></SBDatePicker>
              </div>
            )}
          </div>
          <div className="col-md-3">
            <div className="mb-4">
              <span className="fw-medium">End Date</span>
              <div className="w-75">
                <SBADropDown
                  data={proformaEndDateData.filter(
                    (item) => item.OptionId === 1
                  )}
                  textField={"OptionDescription"}
                  valueField={"OptionId"}
                  value={selectedProformaEndDateData}
                  onChange={(event) => {
                    setProformaEndDateData(event.value);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-4">
              <span className="fw-medium">Allocation Mode</span>
              <div className="w-75">
                <SBADropDown
                  data={allocationModeOptions}
                  textField={"OptionDescription"}
                  valueField={"OptionId"}
                  value={allocationMode}
                  onChange={(event) => {
                    const updatedParams = { ...allocationParams };
                    updatedParams.AllocationMode = event.value;
                    setAllocationParams(updatedParams);
                    setAllocationMode(event.value);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-12 row">
          <div className="col-md-3">
            <div className="mb-4">
              <span className="fw-medium">Rebalance Method</span>
              <div className="w-75">
                <SBADropDown
                  data={proformaRebalanceData}
                  textField={"OptionDescription"}
                  valueField={"OptionId"}
                  value={selectedProformaRebalanceData}
                  onChange={(event) => {
                    const updatedParams = { ...allocationParams };
                    updatedParams.RebalanceMethod = event.value;
                    setAllocationParams(updatedParams);
                    setProformaRebalanceData(event.value);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-4">
              <span className="fw-medium">Rebalance Start</span>
              <div className="w-75">
                <SBADropDown
                  data={proformaRebalanceStartData}
                  textField={"month"}
                  valueField={"index"}
                  value={selectedProformaRebalanceStartData}
                  onChange={(event) => {
                    setProformaRebalanceStartData(event.value);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-4">
              <span className="fw-medium">Backfill</span>
              <div className="w-75">
                <SBADropDown
                  data={ProformaBackfillData}
                  textField={"OptionDescription"}
                  valueField={"OptionId"}
                  value={selectedProformaBackfillData}
                  onChange={(event) => {
                    setProformaBackfillData(event.value);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-4">
              <label className="mb-4 d-flex align-items-center"></label>
              <div className="w-75">
                <label className="mb-4 d-flex align-items-center gap-3">
                  <input
                    type="checkbox"
                    checked={automateReturns === true}
                    onChange={(event) => {
                      setAutomateReturns(event.target.checked);
                    }}
                  />
                  <span className="fw-medium">Automated Returns</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-12 row">
          <div className="col-md-3">
            <div className="d-flex flex-column">
              <div>
                <label className="d-flex align-items-center gap-3">
                  <input
                    type="checkbox"
                    checked={fees === true}
                    onChange={(event) => {
                      setFees(event.target.checked);
                      if (event.target.checked === false) {
                        setFeesValue("");
                      }
                    }}
                  />
                  <span className="fw-medium">Fees (%)</span>
                </label>
              </div>
              <input
                className="form-control w-75"
                type="text"
                value={feesValue}
                disabled={fees === false}
                onChange={FeesPercentageChange}
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-4"></div>
          </div>
        </div>
        <div className="col-lg-12 row"></div>
        <div className="col-lg-12 row">
          <div className="col-lg-6 d-flex gap-1 justify-content-lg-start align-items-center">
            <div></div>
          </div>
        </div>
      </div>
    </>
  );
};
